import { writable } from "svelte/store";

// TODO: store multiple "page" load states

let currentPage;
let loadingPage;
let options = { disableGlobalIndicator: false };

const { subscribe, set } = writable({ loading: false, options });



export default {
  subscribe,
  on(page, options) {
    loadingPage = page
    set({ loading: true, options })
  },
  off(page) {
    if (!page || loadingPage == page)
      set({ loading: false, options })
  }
}
